// @flow

import React from 'react';
import type { Element } from 'react';
import styled from 'styled-components';

const StyledButton = styled.div`
  cursor: pointer;
  ${({ theme }) => theme.Button};
  ${({ styles }) => styles};
`;

type Props = {
  children: string | Element<*> | Array<Element<*>>,
  onClick: Function,
  styles?: Object
};

export default ({ styles, children, ...props }: Props) => (
  <StyledButton styles={styles} {...props}>
    {children}
  </StyledButton>
);



// WEBPACK FOOTER //
// ./src/components/basic-button.js